// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `  .src-js-components-cirium-poweredByCirium-module__text--BGFrI {
  font-size: 12px;
  font-weight: 100;
  line-height: 14px;
  padding-top: 32px;
  }
  
  .src-js-components-cirium-poweredByCirium-module__logo--xbY_h {
    height: 20px;
    width: 70px;
  }

  .src-js-components-cirium-poweredByCirium-module__flexContainer--q5DNR {
    display: flex;
    align-items: center;
    flex-direction: column;
  }

  .src-js-components-cirium-poweredByCirium-module__brandingImage--D8Kue {
    max-height: 70px;
    max-width: 250px;
    width: auto;
    height: auto;
  }

  .src-js-components-cirium-poweredByCirium-module__pageContainer--IyQ8d {
    height: 100%;
  }

  .src-js-components-cirium-poweredByCirium-module__errorContainer--GsRts {
    text-align: center;
    color: "feedback.error";
  }

  .src-js-components-cirium-poweredByCirium-module__formControls--ww811 {
  margin-top: 30px;
  justify-content: center;
}

@media (min-width: 768px) {
  .src-js-components-cirium-poweredByCirium-module__formControls--ww811 {
    justify-content: flex-start;
  }
}`, "",{"version":3,"sources":["webpack://./src/js/components/cirium/poweredByCirium.module.css"],"names":[],"mappings":"EAAE;EACA,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB;;EAEA;IACE,YAAY;IACZ,WAAW;EACb;;EAEA;IACE,aAAa;IACb,mBAAmB;IACnB,sBAAsB;EACxB;;EAEA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,kBAAkB;IAClB,uBAAuB;EACzB;;EAEA;EACA,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE;IACE,2BAA2B;EAC7B;AACF","sourcesContent":["  .text {\n  font-size: 12px;\n  font-weight: 100;\n  line-height: 14px;\n  padding-top: 32px;\n  }\n  \n  .logo {\n    height: 20px;\n    width: 70px;\n  }\n\n  .flexContainer {\n    display: flex;\n    align-items: center;\n    flex-direction: column;\n  }\n\n  .brandingImage {\n    max-height: 70px;\n    max-width: 250px;\n    width: auto;\n    height: auto;\n  }\n\n  .pageContainer {\n    height: 100%;\n  }\n\n  .errorContainer {\n    text-align: center;\n    color: \"feedback.error\";\n  }\n\n  .formControls {\n  margin-top: 30px;\n  justify-content: center;\n}\n\n@media (min-width: 768px) {\n  .formControls {\n    justify-content: flex-start;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"text": `src-js-components-cirium-poweredByCirium-module__text--BGFrI`,
	"logo": `src-js-components-cirium-poweredByCirium-module__logo--xbY_h`,
	"flexContainer": `src-js-components-cirium-poweredByCirium-module__flexContainer--q5DNR`,
	"brandingImage": `src-js-components-cirium-poweredByCirium-module__brandingImage--D8Kue`,
	"pageContainer": `src-js-components-cirium-poweredByCirium-module__pageContainer--IyQ8d`,
	"errorContainer": `src-js-components-cirium-poweredByCirium-module__errorContainer--GsRts`,
	"formControls": `src-js-components-cirium-poweredByCirium-module__formControls--ww811`
};
export default ___CSS_LOADER_EXPORT___;
